import { render, staticRenderFns } from "./Cckc.vue?vue&type=template&id=4e5d3c40&scoped=true&"
import script from "./Cckc.vue?vue&type=script&lang=js&"
export * from "./Cckc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d3c40",
  null
  
)

export default component.exports